import { render, staticRenderFns } from "./AffiliatesStats.vue?vue&type=template&id=4819eda5&scoped=true"
import script from "./AffiliatesStats.vue?vue&type=script&lang=js"
export * from "./AffiliatesStats.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesStats.vue?vue&type=style&index=0&id=4819eda5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819eda5",
  null
  
)

export default component.exports